import React from 'react'
import Modal from 'react-modal'
import { getExtraInfoTabletInformeFacturacionStyles } from '../utils/styles'
import { hideGreyBackground } from '../utils/windows'
import crossIcon from "../../assets/img/cross-modal-icon.png";

const ExtraInfoTabletMobile = (
  {
    isOpenInfoTablet,
    setIsOpenInfoTablet,
    tableData
  }
) => {

  const closeExtraInfoTabletMobile = () => {
    setIsOpenInfoTablet(false)
    hideGreyBackground()
  }

  return (
    <Modal
      isOpen={isOpenInfoTablet}
      onRequestClose={closeExtraInfoTabletMobile}
      style={getExtraInfoTabletInformeFacturacionStyles()}
    >
      <div className='extra-info-tablet-main-container'>
        <div className='modal-header'>
          <div className='label'>
            Detalle Documento
          </div>
          <img src={crossIcon} onClick={closeExtraInfoTabletMobile}/>
        </div>
        <div className='line-separator-modal'></div>
        <div className='modal-data-table-container'>
          <table className="modal-data-table">
            <thead>
              <tr>
                <th className='w-90'>Tipo Detalle</th>
                <th className="align-left">Detalle</th>
              </tr>
            </thead>
            <tr className="table-separator-row-border-top">
              <td colSpan="100%" className='separator-td'/>
            </tr>
            <tbody>
              <tr>
                <td>Tipo</td>
                <td className="align-left">{tableData?.tipo}</td>
              </tr>
              <tr>
                <td>Grupo de Artículos</td>
                <td className="align-left">{tableData?.grupo}</td>
              </tr>
              <tr>
                <td>Neto</td>
                <td className="align-left">{tableData?.neto}</td>
              </tr>
              <tr>
                <td>I.V.A.</td>
                <td className="align-left">{tableData?.iva}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button className='main-button close-button' onClick={closeExtraInfoTabletMobile}>
          Cerrar
        </button>
      </div>
    </Modal>
  )
}

export default ExtraInfoTabletMobile